module.exports = __webpack_public_path__ + "img/website.d401f4c8.svg";